import { render, staticRenderFns } from "./withdrawalInbox.vue?vue&type=template&id=e2f4d73a&scoped=true&"
import script from "./withdrawalInbox.vue?vue&type=script&lang=js&"
export * from "./withdrawalInbox.vue?vue&type=script&lang=js&"
import style0 from "./withdrawalInbox.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./withdrawalInbox.vue?vue&type=style&index=1&id=e2f4d73a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f4d73a",
  null
  
)

export default component.exports